module.exports = __webpack_public_path__ + "img/item2.91115825.png";